/**
 * @module ui/site-header--home
 */
import ee from "lib/eventemitter";

const headerCollapsing = "c-site-header--home--collapsing";
const headerCollapsed = "c-site-header--home--collapsed";
const headerExpanding = "c-site-header--home--expanding";
const headerExpanded = "c-site-header--home--expanded"; // Default state
const headerSticky = "c-site-header--sticky";

let header;

/**
 * @method init
 * @description Additional initialization for this particular header type
 * @param {HTMLElement} headerElement - The header element
 * @param {Function} onScrollCallback - callback method for scroll
 */
export default function init(headerElement, onScrollCallback) {
  header = headerElement;
  const headerTopContent = document.querySelector(".c-site-header__top-content");
  const logo = document.querySelector(".c-site-header__logo--square");
  if (!header || !headerTopContent || !logo) {
    return;
  }

  const minimum = headerTopContent.getBoundingClientRect().height;

  const onPageScroll = scrollPos => {
    onScrollCallback(); // hide benefits menu
    const scrollingBelowHeader = scrollPos > minimum;

    window.requestAnimationFrame(() => {
      if (scrollingBelowHeader) {
        collapseHeader();
      } else {
        expandHeader();
      }
    });
  };
  ee.on("windowScroll.throttled", onPageScroll);

  logo.addEventListener("animationend", onLogoAnimationEnd);
  ee.on("lightbox:opened", onLightboxOpened);
}

/**
 * @method collapseHeader
 * @description Collapses the header by adding/removing various classes
 */
function collapseHeader() {
  if (!header.classList.contains(headerCollapsing) && !header.classList.contains(headerCollapsed)) {
    // IE11 doesn't support multiple arguments for remove()
    header.classList.remove(headerExpanded);
    header.classList.remove(headerExpanding);
    header.classList.add(headerCollapsing);
    header.classList.add(headerSticky);
  }
}

/**
 * @method expandHeader
 * @description Expands the header by adding/removing various classes
 */
function expandHeader() {
  if (!header.classList.contains(headerExpanding) && !header.classList.contains(headerExpanded)) {
    // IE11 doesn't support multiple arguments for remove()
    header.classList.remove(headerCollapsed);
    header.classList.remove(headerCollapsing);
    header.classList.add(headerExpanding);
    header.classList.remove(headerSticky);
  }
}

/**
 * @method onLogoAnimationEnd
 * @description Adds/removes various classes when the logo has finished
 * animating between states
 */
function onLogoAnimationEnd() {
  if (header.classList.contains(headerCollapsing)) {
    header.classList.remove(headerCollapsing);
    header.classList.add(headerCollapsed);
    header.classList.add(headerSticky);
  } else if (header.classList.contains(headerExpanding)) {
    header.classList.remove(headerExpanding);
    header.classList.add(headerExpanded);
    header.classList.remove(headerSticky);
  }
}

/**
 * @method onLightboxOpened
 * @description Adjusts the position/height of the ligtbox backdrop, when required
 */
function onLightboxOpened() {
  const lightbox = document.querySelector(".c-lightbox--menu-panel");
  if (!lightbox) {
    return;
  }
  if (header.classList.contains(headerSticky)) {
    lightbox.style.top = 0;
  } else {
    // Since the header is not sticky at this point, we need to adjust the
    // top position of the lightbox so that it doesn't overlap the header
    lightbox.style.top = header.offsetHeight + "px";
  }
}
